import { render, staticRenderFns } from "./GateDamageSeverity.vue?vue&type=template&id=53ce1892&scoped=true"
import script from "./GateDamageSeverity.vue?vue&type=script&lang=ts"
export * from "./GateDamageSeverity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ce1892",
  null
  
)

export default component.exports